import Axios from "axios";

export const GetRECod = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVCLIs?REG=REGC&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "RECCCCCOD", payload: response.data });
    });
  };
};
